// Seed data for the mock API only. Nothing in components/ or
// pages/ should ever import this file directly — go through
// services/api.ts so swapping in a real backend later is a
// one-file change.

import type { Product } from '@/types/product';

export const STAR_PRODUCTS: Product[] = [
  { id: 's50', category: 'stars', title: '50 Stars', price: 0.99, currency: 'USD', amount: 50 },
  { id: 's100', category: 'stars', title: '100 Stars', price: 1.89, currency: 'USD', amount: 100, tags: ['popular'] },
  { id: 's250', category: 'stars', title: '250 Stars', price: 4.49, currency: 'USD', amount: 250, tags: ['popular'] },
  { id: 's500', category: 'stars', title: '500 Stars', price: 8.99, currency: 'USD', amount: 500 },
  {
    id: 's1000',
    category: 'stars',
    title: '1,000 Stars',
    price: 16.99,
    currency: 'USD',
    amount: 1000,
    badge: 'best-value',
    tags: ['featured'],
  },
  { id: 's2500', category: 'stars', title: '2,500 Stars', price: 39.99, currency: 'USD', amount: 2500, tags: ['featured'] },
];

export const PREMIUM_PRODUCTS: Product[] = [
  {
    id: 'p1',
    category: 'premium',
    title: 'Premium · 1 month',
    subtitle: 'Billed once',
    price: 4.99,
    currency: 'USD',
    durationMonths: 1,
    perMonthPrice: 4.99,
  },
  {
    id: 'p3',
    category: 'premium',
    title: 'Premium · 3 months',
    subtitle: 'Save 12%',
    price: 13.99,
    currency: 'USD',
    durationMonths: 3,
    perMonthPrice: 4.66,
    tags: ['popular'],
  },
  {
    id: 'p6',
    category: 'premium',
    title: 'Premium · 6 months',
    subtitle: 'Save 23%',
    price: 24.99,
    currency: 'USD',
    durationMonths: 6,
    perMonthPrice: 4.16,
  },
  {
    id: 'p12',
    category: 'premium',
    title: 'Premium · 12 months',
    subtitle: 'Save 37%',
    price: 44.99,
    currency: 'USD',
    durationMonths: 12,
    perMonthPrice: 3.75,
    badge: 'best-value',
    tags: ['featured'],
  },
];

export const ALL_PRODUCTS: Product[] = [...STAR_PRODUCTS, ...PREMIUM_PRODUCTS];
